import { render, staticRenderFns } from "./CupsList.vue?vue&type=template&id=f4bc1542&scoped=true"
import script from "./CupsList.ts?vue&type=script&lang=ts&external"
export * from "./CupsList.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4bc1542",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4bc1542')) {
      api.createRecord('f4bc1542', component.options)
    } else {
      api.reload('f4bc1542', component.options)
    }
    module.hot.accept("./CupsList.vue?vue&type=template&id=f4bc1542&scoped=true", function () {
      api.rerender('f4bc1542', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Cups/components/CupsList/CupsList.vue"
export default component.exports